import { createRouterSelector } from '@ngrx/router-store';

export const selectRoutingFeature = createRouterSelector();
